export default __webpack_public_path__ + "/assets/vivi-virtual-tour-360-lg.jpg";